<template>
  <div class="api-catalogue">
    <NavBar></NavBar>
    <main
      property="mainContentOfPage"
      class="container"
      typeof="WebPageElement"
    >
      <Breadcrumb></Breadcrumb>
      <section class="custom-section">
        <div class="columns">
          <div class="column is-7">
            <p class="title">{{ $t("api_catalogue.title") }}</p>
            <p class="large-text">
              {{ $t("api_catalogue.text_1") }}
            </p>
          </div>
          <div class="column is-5">
            <StatusBox />
          </div>
        </div>
      </section>
      <section class="custom-section">
        <div class="columns">
          <div class="column is-12">
            <p class="subtitle is-3">{{ $t("api_catalogue.subtitle_1") }}</p>
            <p>
              {{ $t("api_catalogue.text_2") }}
            </p>
          </div>
        </div>
        <div class="columns">
          <div class="column is-12">
            <p class="subtitle is-3">{{ $t("api_catalogue.subtitle_2") }}</p>
            <p>
              {{ $t("api_catalogue.text_3") }}
            </p>
          </div>
        </div>
      </section>
    </main>
    <BaseFooter></BaseFooter>
  </div>
</template>

<script>
import StatusBox from "@/components/StatusBox.vue";
import NavBar from "@/components/NavBar.vue";
import Breadcrumb from "@/components/Breadcrumb.vue";
import BaseFooter from "@/components/Footer.vue";
export default {
  name: "api-catalogue",
  components: {
    StatusBox,
    NavBar,
    Breadcrumb,
    BaseFooter
  },
  created() {
    document.title = this.$t("api_catalogue.title");
  },
  updated() {
    document.title = this.$t("api_catalogue.title");
  }
};
</script>
